export enum StripeEventType {
  SETUP_INTENT = 'SETUP_INTENT',
  BILLING_PORTAL = 'BILLING_PORTAL',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  INVOICE = 'INVOICE',
}
